import {getId, getType,} from 'apis/model/base'
import _ from 'lodash'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {HostActionTypes} from '../HostContext'
import HostActionRow from '../Settings/HostActionRow'

const renderHostItem = (handleAction = NullAsDefault, renderActions = undefined) => (item, index) => {


    if (!!_.get(item, 'deleted')) {
        return null
    }

    const host = _.get(item, 'host', {})
    const owner = _.get(item, 'owner', {})

    const [id, prop] = [getId(owner), getType(owner),]

    const onLeave = () => {
        handleAction(
            HostActionTypes.LEAVE,
            {
                id,
                prop,
                host_id: getId(item),
            }
        )
    }

    return (
        <div key={index}>
            <HostActionRow
                {...item}
                item={host}
                subItem={owner}
                params={{ host_id: getId(item) }}
                status={item?.status}
                Actions={
                    _.isFunction(renderActions)
                        ? () =>
                            renderActions({
                                onLeave,
                            })
                        : undefined
                }
                canLeave={false}
            />
        </div>
    )
}

export default renderHostItem
